export default __webpack_public_path__ + "locales/fr/OAuth.json?hash=ffa5ffdd715d94ac2fcadea0fa8a6d04";